import React, {useEffect, useState} from 'react';
import './style.less'


function Page(props) {

    let {defaultCurrent, total = 0, totalPage, pageSize = 20,selectPage = true, pageChange, onChange} = props;

    const [currentPage, setCurrentPage] = useState(defaultCurrent)
    const [groupCount, setGroupCount] = useState(3)
    const [startPage, setStartPage] = useState(parseInt(defaultCurrent) - 2 > 0 ? parseInt(defaultCurrent) - 2 : parseInt(defaultCurrent))


    useEffect(() => {
        setCurrentPage(defaultCurrent)
    }, [defaultCurrent])

    let createPage = () => {
        let pages = [];
        //上一页
        pages.push(<li className={currentPage == 1 ? "buttonBox nomore" : 'buttonBox'}
                       key={0}>
            <div className={'pageButton'} onClick={prePageHandeler}>
                <img src={require('@/images/left.png')} alt=""/>
            </div>
        </li>)

        if (totalPage <= 10) {
            /*总页码小于等于10时，全部显示出来*/
            for (let i = 1; i <= totalPage; i++) {
                pages.push(<li key={i} onClick={() => pageClick(i)}
                               className={currentPage == i ? "activePage" : null}>{i}</li>)
            }
        } else {
            /*总页码大于10时，部分显示*/
            //第一页
            pages.push(<li className={currentPage == 1 ? "activePage" : null} key={1}
                           onClick={() => pageClick(1)}>1</li>)
            let pageLength = 0;
            if (groupCount + startPage > totalPage) {
                pageLength = totalPage;
            } else {
                pageLength = groupCount + startPage;

            }
            //前面省略号(当当前页码比分组的页码大时显示省略号)
            if (currentPage >= groupCount) {
                pages.push(<li className="omission" key={-1}>···</li>)
            }
            //非第一页和最后一页显示
            for (let i = startPage; i < pageLength; i++) {
                if (i <= totalPage - 1 && i > 1) {
                    pages.push(<li className={currentPage === i ? "activePage" : null} key={i}
                                   onClick={() => pageClick(i)}>{i}</li>)
                }
            }
            //后面省略号
            if (totalPage - startPage >= groupCount + 1) {
                pages.push(<li className="omission" key={-2}>···</li>)
            }
            //最后一页
            pages.push(<li className={currentPage == totalPage ? "activePage" : null} key={totalPage}
                           onClick={() => pageClick(totalPage)}>{totalPage}</li>)
        }
        //下一页
        pages.push(<li className={currentPage == totalPage ? "buttonBox nomore" : 'buttonBox'}
                       key={totalPage + 1}>
            <div className={'pageButton'} onClick={nextPageHandeler}>
                <img src={require('@/images/right.png')} alt=""/>
            </div>
        </li>)
        return pages;
    }

    let createPage1 =  (currentPage, groupCount, totalPage)=>{
        let pages = "";

        //上一页
        pages += `<a class="disabled addPage" >上一页</a>`

        // 无省略页码, 如果总页数 <= 分页按钮数量, 则按实际页数输出按钮;
        if (totalPage <= groupCount) {
            for (let i = 1; i <= totalPage; i++) {
                if (currentPage == i) {
                    pages += `<a class="act page" data-page='${i}'>${i}</a>`
                    continue
                }

                pages += `<a class="page" data-page='${i}'>${i}</a>`
            }

            //下一页
            pages += `<a class="disabled" id="nextPage">下一页</a>`
            return pages;
        }

        // 省略页面码在前, 如果当前页 为 最后3页, 则起始页 = 总页数 - 分页按钮数量 + 1,起始页的下一页为省略页码;
        if (currentPage > totalPage - (groupCount - 3)) {
            let start = totalPage - groupCount + 1;
            for (let i = start; i <= totalPage; i++) {
                if (currentPage == i) {
                    pages += `<a class="act page" data-page='${i}'>${i}</a>`
                    continue;
                }
                if (i == start) {
                    pages += `<a class="page" data-page='1'>1</a>`
                    continue;
                }
                if (i == start + 1) {
                    pages += `<a>···</a>`
                    continue;
                }
                pages += `<a class="page" data-page='${i}'>${i}</a>`
            }

            //下一页
            pages += `<a class="disabled" id="nextPage">下一页</a>`

            return pages;
        }

        // 省略页面码在后, 如果当前页 为 分页按钮数量 - 2,不是最后两个按钮上, 则 倒数第二个按钮为省略页码,最后一个按钮为最后一页;
        if (currentPage < groupCount - 2) {
            for (let i = 1; i <= groupCount; i++) {
                if (currentPage == i) {
                    pages += `<a class="act page" data-page='${i}'>${i}</a>`
                    continue;
                }
                if (i == groupCount - 1) {
                    pages += `<a>···</a>`
                    continue;
                }
                if (i == groupCount) {
                    pages += `<a class="page" data-page='${totalPage}'>${totalPage}</a>`
                    continue;
                }
                pages += `<a class="page" data-page='${i}'>${i}</a>`
            }

            //下一页
            pages += `<a class="disabled" id="nextPage">下一页</a>`

            return pages;
        }

        // 否则省略页码存在于两端, 第二个和倒数第二个按钮为省略按钮, 第一个和倒数第一个, 分别为第一页和最后一页, 当前页 位于剩余按钮的中间, 所以左右按钮分别为当前页递减递增;
        pages += `<a class="page" data-page='1'>1</a>`
        pages += `<a>···</a>`

        let start, end, diss;
        if ((groupCount - 4) % 2) {
            diss = (groupCount - 4 - 1) / 2;
            start = currentPage - diss;
            end = currentPage + diss;
        } else {
            diss = (groupCount - 4) / 2;
            start = currentPage - diss;
            if (start == 2) {
                start = currentPage - diss + 1;
                end = currentPage + diss;
            } else {
                end = currentPage + diss - 1;
            }

        }

        for (let i = start; i <= end; i++) {
            if (currentPage == i) {
                pages += `<a class="act page" data-page='${i}'>${i}</a>`
                continue;
            }
            pages += `<a class="page" data-page='${i}'>${i}</a>`
        }

        pages += `<a>···</a>`
        pages += `<a class="page" data-page='${totalPage}'>${totalPage}</a>`

        //下一页
        pages += `<a class="disabled" id="nextPage">下一页</a>`

        return pages

    }


    //页码点击
    let pageClick = (currentPage) => {
        //当 当前页码 大于 分组的页码 时，使 当前页 前面 显示 两个页码
        if (currentPage >= groupCount) {
            setStartPage(currentPage - 2)
        }
        if (currentPage < groupCount) {
            setStartPage(1)
        }
        //第一页时重新设置分组的起始页
        if (currentPage === 1) {
            setStartPage(1)
        }
        setCurrentPage(currentPage)

        //将当前页码返回父组件
        onChange(currentPage)
    }

    //上一页事件
    let prePageHandeler = () => {
        if (currentPage - 1 === 0) {
            return false;
        }
        pageClick(currentPage - 1)
    }

    //下一页事件
    let nextPageHandeler = () => {
        // const {totalPage} = this.props.pageConfig;
        if (currentPage + 1 > totalPage) {
            return false;
        }
        pageClick(currentPage + 1)
    }


    return (
        <div className="page_container">
            <ul>
                <div className={'page-total'}>
                    共 {total} 条
                </div>
                {
                    selectPage &&        <div className={'page-total'}>
                        每页
                        <select className={'select_box'} value={pageSize.toString()}
                                onChange={pageChange}>
                            <option value="20">20/页</option>
                            <option value="50">50/页</option>
                            <option value="100">100/页</option>
                        </select>
                        条
                    </div>
                }


                {createPage()}
            </ul>
        </div>
    );
}

export default Page;